import * as React from "react";
import * as _ from "lodash";
import { IPatientSystemReview } from "@curefit/ehr-common";
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard";
import IStaticDataValue from "../../models/staticData/IStaticDataValue";
import IEditedBy from "../../models/IEditedBy";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils";
import {SourceConstants} from "../../utils/AppConstants";

interface ReviewOfSystemsEditViewContProps {
    editedBy: IEditedBy,
    patientId: number,
    cardTitle: string,
    displayMode: EditViewDisplayMode,
    staticReviewSystemsData: IStaticDataValue[],
    reviewOfSystemsData: IPatientSystemReview[],
    appointmentId: number
}

interface ReviewOfSystemsEditViewContState {
    updatedData: IPatientSystemReview[],
    isPatientExamsDataLoaded: LOADING_STATE
}

export default class ReviewOfSystemsEditViewCont extends React.Component<ReviewOfSystemsEditViewContProps, ReviewOfSystemsEditViewContState> {

    constructor(props: ReviewOfSystemsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    getStateFromProps = (props: ReviewOfSystemsEditViewContProps) => {
        let currState: ReviewOfSystemsEditViewContState = {
            updatedData: [],
            isPatientExamsDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.reviewOfSystemsData) ) {
            // props.fetchPatientExams(this.props.patientId);
            // currState.isPatientExamsDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedData = props.reviewOfSystemsData;
            currState.isPatientExamsDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    };

    getReviewSystemsEditViewTemplateProps = () => {
        const ReviewSystemsViewProps = {
            reviewOfSystemsData: this.props.reviewOfSystemsData
        };
        const ReviewSystemsEditorProps = {
            staticReviewSystemsData: this.props.staticReviewSystemsData,
            updateSystemsReview: this.updateData,
            selectedData: this.state.updatedData,
            reviewOfSystemsData: this.props.reviewOfSystemsData
        }

        return {
            "view": ReviewSystemsViewProps,
            "edit": ReviewSystemsEditorProps
        }
    };

    updateData = (updatedData: IPatientSystemReview[]) => {
        this.setState({updatedData});
    };

    getSaveObject = (): IPatientSystemReview[] => {
        const { updatedData } = this.state;
        let savedData: IPatientSystemReview[] = [];
        if (!_.isEmpty(updatedData)) {
            _.map(updatedData, (data)  => {
                let sanitizedData = AppUtils.sanitizeRequestItemBeforeSave(data);
                if (this.props.appointmentId !== undefined) sanitizedData.appointmentId = this.props.appointmentId;
                sanitizedData.source = SourceConstants.DOCSASPP;
                sanitizedData.lastEditedPersonId = parseInt(this.props.editedBy.id);
                sanitizedData.personType = this.props.editedBy.role.toLowerCase();
                sanitizedData.patientId = this.props.patientId;
                sanitizedData.isDeleted = false;
                savedData.push(sanitizedData);
            });
            return savedData;
        }
        else return null;
    };

    render () {
        const lastEditedEpoch = new Date().getTime();
        return (
            <div className={"review-systems-edit-view-cont"}>
                <EditViewCard
                    displayMode={this.props.displayMode}
                    cardTitleDisplay={"Review Of Systems"}
                    templateName={"reviewSystems"}
                    templateProps={this.getReviewSystemsEditViewTemplateProps()}
                    lastEditedEpoch={lastEditedEpoch} saveActionHandler={} cancelActionHandler={}/>
            </div>
        )
    }
}